import React, { FC, useState } from 'react'

import { Button, Grid } from '@material-ui/core'

import useStyles from '../styles/useStyles'
import { CurrentPhotoError } from 'constants/Constants'
import { getCurrentBadgePhoto } from '../services/ImageService'
import RemotelyProcessedImageWrapper from 'components/photo/RemoteProcessedPhoto'

interface IProps {
    onPhotoRetrieved: (image: string) => void
}

export const UseCurrentPhotoComponent: FC<IProps> = ({ onPhotoRetrieved }) => {
    const classes = useStyles()
    const [isRetrieving, setIsRetrieving] = useState<boolean>(false)
    const [errorReason, setErrorReason] = useState<string>('')

    const handleRetrievePhoto = async () => {
        setIsRetrieving(true)
        setErrorReason('')
        try {
            const picture = await getCurrentBadgePhoto()
            if (picture) {
                // Do NOT setIsRetrieving(false) here: the parent will unmount this
                // component and switch to useImageProcessing.isProcessing, so the
                // backdrop stays visible with no visible gap between the two states.
                onPhotoRetrieved('data:image/jpeg;base64,' + picture)
                return
            }
            setErrorReason(CurrentPhotoError.NotFound)
            // eslint-disable-next-line
        } catch (error: any) {
            const status = error?.response?.status ?? error?.status
            if (status === 404) {
                setErrorReason(CurrentPhotoError.NotFound)
            } else {
                setErrorReason(CurrentPhotoError.Generic)
            }
        }
        setIsRetrieving(false)
    }

    return (
        <RemotelyProcessedImageWrapper processingError={errorReason} isProcessing={isRetrieving}>
            <div className={classes.viewPhotoTop}>
                <div className={classes.viewPhotoText}>Retrieve your current badge photo to use for this request.</div>
                <Grid container justify="center" spacing={1}>
                    <Grid item xs={12} sm={4}>
                        <Button variant="contained" color="primary" className={classes.viewPhotoButton} onClick={handleRetrievePhoto} disabled={isRetrieving}>
                            Retrieve Current Badge Photo
                        </Button>
                    </Grid>
                </Grid>
            </div>
        </RemotelyProcessedImageWrapper>
    )
}
